/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_1_QInputs */

const en_landing_faq_1_q = /** @type {(inputs: Landing_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is Alchema and how does it help with job applications?`)
};

const de_landing_faq_1_q = /** @type {(inputs: Landing_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist Alchema und wie hilft es bei der Bewerbung?`)
};

const fr_landing_faq_1_q = /** @type {(inputs: Landing_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce qu'Alchema et comment aide-t-il pour les candidatures ?`)
};

const es_landing_faq_1_q = /** @type {(inputs: Landing_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que es Alchema y como ayuda con las solicitudes de empleo?`)
};

const it_landing_faq_1_q = /** @type {(inputs: Landing_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'e Alchema e come aiuta con le candidature?`)
};

const nl_landing_faq_1_q = /** @type {(inputs: Landing_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is Alchema en hoe helpt het bij sollicitaties?`)
};

const pl_landing_faq_1_q = /** @type {(inputs: Landing_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czym jest Alchema i jak pomaga w aplikacjach o prace?`)
};

const fi_landing_faq_1_q = /** @type {(inputs: Landing_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mika on Alchema ja miten se auttaa tyohakemuksissa?`)
};

const da_landing_faq_1_q = /** @type {(inputs: Landing_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvad er Alchema, og hvordan hjaelper det med jobansogninger?`)
};

const sv_landing_faq_1_q = /** @type {(inputs: Landing_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vad aer Alchema och hur hjaelper det med jobbansokningar?`)
};

/**
* | output |
* | --- |
* | "What is Alchema and how does it help with job applications?" |
*
* @param {Landing_Faq_1_QInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_faq_1_q = /** @type {((inputs?: Landing_Faq_1_QInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_1_QInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_faq_1_q(inputs)
	if (locale === "fr") return fr_landing_faq_1_q(inputs)
	if (locale === "es") return es_landing_faq_1_q(inputs)
	if (locale === "it") return it_landing_faq_1_q(inputs)
	if (locale === "nl") return nl_landing_faq_1_q(inputs)
	if (locale === "pl") return pl_landing_faq_1_q(inputs)
	if (locale === "fi") return fi_landing_faq_1_q(inputs)
	if (locale === "da") return da_landing_faq_1_q(inputs)
	if (locale === "sv") return sv_landing_faq_1_q(inputs)
	return en_landing_faq_1_q(inputs)
});